<template>
    <header>
        <div class="top-menu">
            <div class="top-menu__service-logo">
                <img src="@/assets/logo.svg" />
            </div>
            <div class="top-menu__btn-wrapper">
                <button v-if="status === 'APPLY'" @click="handleMenu('history')">예약 신청내역</button>
                <button v-if="status === 'HISTORY'" @click="handleMenu('apply')">방문예약 신청</button>
            </div>
        </div>
        <div class="reservation-title">
            <div class="title" v-html="title"></div>
        </div>
        <div class="school-info" v-if="school">
            <div class="school-info__logo">
                <img
                    :src="store.school.prof_url"
                    title="학교로고"
                />
            </div>
            <div class="school-info__name" v-html="store.school.name">

            </div>
        </div>
    </header>
</template>

<script>
import { store } from "@/store";

export default {
    name: "GlobalHeader",
    data: () => ({
       store
    }),
    props: {
        status: String,
        school: Number,
        title: String
    },
    methods: {
        handleMenu(menu) {
            switch(menu) {
                case "apply": this.$router.replace({ path: `/schools/${store.school.id}/visit/apply` }); break;
                case "history": this.$router.replace({ path: `/schools/${store.school.id}/visit/history` }); break;
            }
        }
    }
};
</script>

<style lang="scss" src="../../styles/_reservation.scss"></style>
